// extracted by mini-css-extract-plugin
module.exports = {"root":"AddTileButton_root__hNZuG","rootSmall":"AddTileButton_rootSmall__jQDLr"};